import { render, staticRenderFns } from "./ConsultaDeclaracoesNotaFiscal.vue?vue&type=template&id=236d7afc&scoped=true&"
import script from "./ConsultaDeclaracoesNotaFiscal.vue?vue&type=script&lang=js&"
export * from "./ConsultaDeclaracoesNotaFiscal.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaDeclaracoesNotaFiscal.vue?vue&type=style&index=0&id=236d7afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236d7afc",
  null
  
)

export default component.exports